module.exports = __webpack_public_path__ + "img/menu_DOCL.f3bfde4f.svg";